import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const servicesApi = createApi({
  reducerPath: "servicesApi",
  tagTypes: ["Booking", "CustomBooking"],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getServices: builder.query({
      query: (params = {}) => ({ url: "/services", params }),
    }),
    getService: builder.query({
      query: (id) => `/services/${id}`,
    }),
    getSlots: builder.query({
      query: ({ serviceId, date }) => `/slots?serviceId=${serviceId}&date=${date}`,
    }),
    getBookings: builder.query({
      query: () => "/bookings",
      providesTags: ["Booking"],
    }),
    createBooking: builder.mutation({
      query: (body) => ({ url: "/bookings", method: "POST", body }),
      invalidatesTags: ["Booking"],
    }),
    updateProfile: builder.mutation({
      query: (body) => ({ url: "/auth/me", method: "PATCH", body }),
    }),
    uploadAvatar: builder.mutation({
      query: (formData) => ({ url: "/upload/avatar", method: "POST", body: formData }),
    }),
    changePassword: builder.mutation({
      query: (body) => ({ url: "/auth/change-password", method: "POST", body }),
    }),
    getDailySlots: builder.query({
      query: () => "/daily-slots",
    }),
    getCustomBookings: builder.query({
      query: () => "/custom-bookings",
      providesTags: ["CustomBooking"],
    }),
    createCustomBooking: builder.mutation({
      query: (body) => ({ url: "/custom-bookings", method: "POST", body }),
      invalidatesTags: ["CustomBooking"],
    }),
    userRespondCustomBooking: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/custom-bookings/${id}/user-respond`, method: "PATCH", body }),
      invalidatesTags: ["CustomBooking"],
    }),
  }),
});

export const {
  useGetServicesQuery,
  useGetServiceQuery,
  useGetSlotsQuery,
  useLazyGetSlotsQuery,
  useGetBookingsQuery,
  useCreateBookingMutation,
  useUpdateProfileMutation,
  useUploadAvatarMutation,
  useChangePasswordMutation,
  useGetDailySlotsQuery,
  useGetCustomBookingsQuery,
  useCreateCustomBookingMutation,
  useUserRespondCustomBookingMutation,
} = servicesApi;
